import React, { FC } from "react";
import styles from "./EmptyTablePlaceholder.module.scss";

interface Props {
  text: string;
}
export const EmptyTablePlaceholder: FC<Props> = ({ text }) => {
  return <p className={styles.placeholder}>{text}</p>;
};
